export type Priority = 'urgence' | 'action' | 'service' | 'activite' | 'statut' | 'suggestion'

export interface ForYouItem {
  id: string
  priority: Priority
  eyebrow: string
  title: string
  detail: string
  cta: string
  to: string
}

export interface EspaceService {
  id: string
  name: string
  context: string
  icon: 'card' | 'trash' | 'ball' | 'request' | 'booking' | 'invoice' | 'bell' | 'pet'
  to: string
}

export const citizenFirstName = 'Charlotte'

export const forYouItems: ForYouItem[] = [
  {
    id: 'ebullition',
    priority: 'urgence',
    eyebrow: 'Avis d’ébullition',
    title: 'Votre adresse du 112, route 138 est concernée.',
    detail: 'En vigueur depuis aujourd’hui, 14 h 30.',
    cta: 'Voir les consignes',
    to: '/notifications',
  },
  {
    id: 'centre-de-tri',
    priority: 'service',
    eyebrow: 'Centre de tri',
    title: 'Fermé le samedi 19 septembre',
    detail: 'Deuxième fermeture du mois · ouverture habituelle les samedis de 8 h à 16 h',
    cta: 'Voir l’horaire',
    to: '/mes-collectes',
  },
  {
    id: 'collecte',
    priority: 'service',
    eyebrow: 'Collectes',
    title: 'Collecte aujourd’hui',
    detail: 'Ordures · Recyclage · bacs à sortir dès 17 h la veille',
    cta: 'Voir mes collectes',
    to: '/mes-collectes',
  },
  {
    id: 'demande',
    priority: 'statut',
    eyebrow: 'Demande #REQ-2841',
    title: 'Nid-de-poule — nouveau statut : En traitement',
    detail: '112, route 138 · mis à jour le 28 août',
    cta: 'Suivre ma demande',
    to: '/mes-demandes/req-2841',
  },
  {
    id: 'milo',
    priority: 'action',
    eyebrow: 'Mon animal',
    title: 'Rappel de vaccin pour Milo',
    detail: 'Prévu le 14 octobre · information partagée par la clinique vétérinaire',
    cta: 'Voir Milo',
    to: '/mes-animaux/milo',
  },
  {
    id: 'bail',
    priority: 'action',
    eyebrow: 'Bail de villégiature',
    title: 'Renouvellement à venir',
    detail: 'Chemin du Vieux-Phare · facture à payer',
    cta: 'Voir ma facture',
    to: '/mon-profil',
  },
]

export const espaceServices: EspaceService[] = [
  {
    id: 'carte',
    name: 'Carte numérique',
    context: 'Active · preuve de résidence au centre de tri',
    icon: 'card',
    to: '/ma-carte',
  },
  {
    id: 'collectes',
    name: 'Collectes',
    context: 'Collecte aujourd’hui',
    icon: 'trash',
    to: '/mes-collectes',
  },
  {
    id: 'loisirs',
    name: 'Bibliothèque et loisirs',
    context: '2 documents à rapporter',
    icon: 'ball',
    to: '/mes-loisirs',
  },
  { id: 'demandes', name: 'Mes demandes', context: '1 demande en traitement', icon: 'request', to: '/mes-demandes' },
  {
    id: 'reservations',
    name: 'Réservations',
    context: 'Salle communautaire',
    icon: 'booking',
    to: '/mes-loisirs',
  },
  { id: 'factures', name: 'Factures', context: '1 facture à payer', icon: 'invoice', to: '/mon-profil' },
  { id: 'avis', name: 'Notifications', context: '3 avis non lus', icon: 'bell', to: '/notifications' },
  { id: 'animaux', name: 'Mes animaux', context: 'Milo · licence active', icon: 'pet', to: '/mes-animaux' },
]

export const discoverItems = [
  {
    id: 'equipement',
    title: 'Découvrez la réservation de la salle communautaire',
    detail: 'Réservez la salle du centre communautaire en ligne.',
    to: '/mes-loisirs',
  },
  {
    id: 'rappels',
    title: 'Recevez les rappels de collecte',
    detail: 'Un avis la veille, sur le canal de votre choix.',
    to: '/notifications/parametres',
  },
]

export interface EspaceNavItem {
  id: string
  label: string
  icon: 'home' | 'card' | 'profile' | 'bell' | 'trash' | 'water' | 'request' | 'ball' | 'permit'
  to: string
}

export const espaceNav: EspaceNavItem[] = [
  { id: 'accueil', label: 'Accueil', icon: 'home', to: '/mon-espace' },
  { id: 'carte', label: 'Ma carte', icon: 'card', to: '/ma-carte' },
  { id: 'profil', label: 'Mon profil', icon: 'profile', to: '/mon-profil' },
  { id: 'avis', label: 'Notifications', icon: 'bell', to: '/notifications' },
  { id: 'collectes', label: 'Mes collectes', icon: 'trash', to: '/mes-collectes' },
  { id: 'eau', label: 'Compteur d’eau', icon: 'water', to: '/mon-compteur-eau' },
  { id: 'loisirs', label: 'Loisirs', icon: 'ball', to: '/mes-loisirs' },
  { id: 'requete', label: 'Requête', icon: 'request', to: '/mes-demandes' },
  { id: 'permis', label: 'Permis', icon: 'permit', to: '/mes-permis' },
]

export interface LocalNewsItem {
  id: string
  date: string
  category: string
  title: string
  image: string
  to?: string
}

export const localNews: LocalNewsItem[] = [
  {
    id: 'centre-de-tri',
    date: '18 septembre 2026',
    category: 'Matières résiduelles',
    title: 'Petit rappel : le centre de tri sera fermé le samedi 19 septembre',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/2ef9976a-f50f-4cc2-9ce3-dc04e5ff5f75.jpg',
    to: '/mes-collectes',
  },
  {
    id: 'chats-errants',
    date: '17 septembre 2026',
    category: 'Avis à la population',
    title: 'Journées de stérilisation de chats errants les 25 et 26 septembre',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/6cdfd633-9816-44b7-a1b8-b036963e610c.jpg',
  },
  {
    id: 'seance-extraordinaire',
    date: '20 août 2026',
    category: 'Avis public',
    title: 'Avis public — séance extraordinaire le mardi 25 août à 19 h',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/32c4eb13-3a40-4b92-9946-2826839ad487.jpg',
  },
]

export interface NearbyEvent {
  id: string
  date: string
  time?: string
  title: string
  image: string
}

export const nearbyEvents: NearbyEvent[] = [
  {
    id: 'activite-communautaire',
    date: 'Sam. 19 sept.',
    time: 'Au village',
    title: 'Activité communautaire',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/157c66ce-e0fd-4449-a411-6758d4d4ce95.jpg',
  },
  {
    id: 'rgmrm',
    date: 'Mar. 22 sept.',
    time: 'Public dès 11 h',
    title: 'Assemblée de la RGMRM',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/2ef9976a-f50f-4cc2-9ce3-dc04e5ff5f75.jpg',
  },
  {
    id: 'chats-errants',
    date: '25 et 26 sept.',
    title: 'Journées de stérilisation de chats errants',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/6cdfd633-9816-44b7-a1b8-b036963e610c.jpg',
  },
]

export interface UsefulService {
  id: string
  name: string
  open: boolean
  hours: string
  image: string
}

export const usefulServices: UsefulService[] = [
  {
    id: 'bureau',
    name: 'Bureau municipal',
    open: false,
    hours: 'Ouvre lundi',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/74531504-b049-4345-9cdb-f2c5b4a35dea.jpg',
  },
  {
    id: 'biblio',
    name: 'Bibliothèque municipale',
    open: true,
    hours: 'Consulter l’horaire',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e1f25ce2-6474-4e4d-b9dc-6cd547bd0bb7.jpg',
  },
  {
    id: 'centre-de-tri',
    name: 'Centre de tri de Baie-Trinité',
    open: false,
    hours: 'Fermé le 19 septembre',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/2ef9976a-f50f-4cc2-9ce3-dc04e5ff5f75.jpg',
  },
  {
    id: 'communautaire',
    name: 'Centre communautaire',
    open: true,
    hours: 'Sur réservation',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/32c4eb13-3a40-4b92-9946-2826839ad487.jpg',
  },
  {
    id: 'incendie',
    name: 'Service incendie',
    open: true,
    hours: 'Urgences : 911',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/92a36bac-9dd5-47b0-884c-20dd82999fe3.jpg',
  },
]

export const appBenefits = [
  { id: 'carte', label: 'Votre carte toujours avec vous', icon: 'card' },
  { id: 'alertes', label: 'Recevez ce qui vous concerne', icon: 'bell' },
  { id: 'lieu', label: 'Des services adaptés à l’endroit où vous êtes', icon: 'pin' },
  { id: 'photo', label: 'Signalez un problème en quelques secondes', icon: 'camera' },
  { id: 'acces', label: 'Accédez à vos services et à vos factures', icon: 'key' },
] as const

export const mobileItems = [
  { id: 'collecte', eyebrow: 'Collecte aujourd’hui', detail: 'Ordures · Recyclage' },
  { id: 'centre-de-tri', eyebrow: 'Centre de tri', detail: 'Fermé samedi' },
  { id: 'demande', eyebrow: 'Demande #2841', detail: 'En traitement' },
]
